<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <div class="userdetailside">
        <sidebarSettingsComponent></sidebarSettingsComponent>
      </div>
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main" style="width:75%;">
        <b-row class="col-md-12 userdetailsidebar">
          <b-col md="12">
            <!-- <div class="pull-right"> -->
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <!--  <span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span> -->
                <i
                  class="fa fa-sliders"
                  aria-hidden="true"
                  style="font-size:20px"
                ></i>
              </template>
              <b-dropdown-item style="font-size: 16px;">
                <div>
                  <router-link
                    to="/updateProfile"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Collections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;
                    <span>Profile</span>
                  </router-link>
                </div>
                <div
                  v-if="
                    this.user_type == 'Admin' ||
                      this.user_type == 'Brand_Manager' ||
                      this.user_type == 'Quality_Head' ||
                      this.user_type == 'Quality_Controller'
                  "
                >
                  <router-link
                    to="/usersdetails"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Collections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;
                    <span>Manage Users</span>
                  </router-link>
                </div>
                <div
                  v-if="
                    this.user_type == 'Brand_Manager' ||
                      this.user_type == 'Quality_Head'
                  "
                >
                  <router-link
                    to="/mybranddetails"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Collections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-shopping-cart" aria-hidden="true"></i
                    >&nbsp;&nbsp;&nbsp;
                    <span>My Brands</span>
                  </router-link>
                </div>
                <div style="display:none">
                  <router-link
                    to="/updateProfile"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Coll ections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp;
                    <span>Manage Vendors</span>
                  </router-link>
                </div>
                <div v-if="this.user_type == 'Admin'">
                  <router-link
                    to="/manage_brands"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Coll ections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp;
                    <span>Manage Brands</span>
                  </router-link>
                </div>
                <div v-if="this.user_type == 'Admin'">
                  <router-link
                    to="/marginmaster"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Coll ections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-pie-chart" aria-hidden="true"></i>

                    &nbsp;&nbsp;&nbsp;
                    <span>Manage Margin Master</span>
                  </router-link>
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <!-- </div> -->
          </b-col>
        </b-row>
        <div class="col-md-12 ">
          <!-- code for table -->
          <b-row>
            <div class="col-md-12">
              <b-col md="12">
                <b-card-body>
                  <b-row class="mt-2">
                    <b-col cols="4">
                      <h3>User Details</h3>
                                        <span v-if="
                        user_type == 'Admin'
                      "
                    ><i
                      class="fa fa-circle"
                      aria-hidden="true"
                      style="color: red"
                    
                    ></i>
                    Indicates user created by the Admin</span
                  >

                  <span v-if="
                        user_type == 'Buyer'
                      "
                    ><i
                      class="fa fa-circle"
                      aria-hidden="true"
                      style="color: red"
                    
                    ></i>
                    Indicates user created by the Buyer</span
                  >

                  <span v-if="
                        user_type == 'Brand_Manager'
                      "
                    ><i
                      class="fa fa-circle"
                      aria-hidden="true"
                      style="color: red"
                    
                    ></i>
                    Indicates user created by the BM</span
                  >

                  <span v-if="
                        user_type == 'Quality_Controller'
                      "
                    ><i
                      class="fa fa-circle"
                      aria-hidden="true"
                      style="color: red"
                    
                    ></i>
                    Indicates user created by the Quality Controller</span
                  >

                  <span v-if="
                        user_type == 'Planner_Admin'
                      "
                    ><i
                      class="fa fa-circle"
                      aria-hidden="true"
                      style="color: red"
                    
                    ></i>
                    Indicates user created by the Planner Admin</span
                  >
 

                    </b-col>
                    <b-col cols="7">
                      <input
                        type="text"
                        id="myInput"
                        v-model="searchuser"
                        @input="searchuserfromlist(searchuser)"
                        placeholder="Search for names..."
                        title="Type in a name"
                        class="form-control"
                      />
                    </b-col>
                   
                  </b-row>
                  <b-row class="mt-2"  v-if="
                          user_type != 'Brand_Designer' &&
                          user_type != 'Design_Head'
                      ">

                    <!-- <b-col cols="3 ml-5" v-if="
                            user_type != 'Admin' &&
                              user_type != 'Quality_Controller' 
                          "
                        >
                          <router-link to="/addusersdetails"
                            ><input
                              class="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios2"
                              value="option1"
                            /><label
                              class="form-check-label"
                              for="exampleRadios2"
                              >Add New User</label
                            ></router-link
                          >
                    </b-col> -->
                    <b-col cols="3  ml-5"  v-if="
                            user_type != 'Admin' &&
                              user_type != 'Quality_Controller' &&
                               user_type != 'Buyer' &&
                                user_type != 'Planner_Admin'
                          "
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="exampleRadios1"
                            id="exampleRadios1"
                            value="option1"
                            @click="showexistinguser(); getexistinguserlist(null)"
                          /><label class="form-check-label" for="exampleRadios1"
                            >Add Existing User</label
                          >
                    </b-col>

                     <b-col cols="3 ml-2" v-if="
                          user_type == 'Admin' ||
                            user_type == 'Quality_Controller' ||
                              user_type != 'Buyer' ||
                                user_type != 'Brand_Manager'
                                
                        "
                      >
                        <router-link to="/addusersdetails" v-if="user_type != 'Planner_Admin'">
                          <button class="btn btn-sm btn-primary" type="button">
                            <i class="fa fa-plus"></i> Add User
                          </button>
                        </router-link>
                    </b-col>
                  </b-row>
                 


                  <div class="float-right">
                    <p>
                      <b
                        >Total Records :<span style="color:red;">{{
                          CreatedUser_totalRows
                        }}</span></b
                      >
                    </p>
                  </div>
                  <b-col md="12">
                    <b-table
                      class="mt-4"
                      show-empty
                      stacked="md"
                      :busy="isBusy"
                      :items="items"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :bordered="bordered"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFiltered"
                      :sort-direction="sortDirection"
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>

                      <template slot="user_id" slot-scope="row">
                        <i
                          class="fa fa-circle"
                          aria-hidden="true"
                          style="color: red"
                          v-if="
                            row.item.org_brand_manger ==
                              row.item.other_brand_manger &&
                              user_type != 'Admin' &&
                              user_type != 'Quality_Controller'
                          "
                        ></i
                        >&nbsp;
                        <!-- {{user_id}} -->
                        <span>{{ row.item.user_id }}</span>
                      </template>
                      <template slot="user_type" slot-scope="row">
                        <span @click="toggleInfoModal(row.item)">
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '0'"
                          >
                            <span class="badge badge-danger">Admin</span>
                          </span>

                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '1'"
                          >
                            <span class="badge badge-primary"
                              >Brand Manager</span
                            >
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '2'"
                          >
                            <span class="badge badge-success">Buyer</span>
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '10'"
                          >
                            <span class="badge badge-success">Junior Buyer</span>
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '3'"
                          >
                            <span class="badge badge-success">Designer</span>
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '9'"
                          >
                            <span class="badge badge-success"
                              >Graphics Designer</span
                            >
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '4'"
                          >
                            <span class="badge badge-success"
                              >Fit Technician</span
                            >
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '5'"
                          >
                            <span class="badge badge-success">Design Head</span>
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '6'"
                          >
                            <span class="badge badge-success"
                              >PO Executive</span
                            >
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '7'"
                          >
                            <span class="badge badge-success"
                              >Quality Controller</span
                            >
                          </span>
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '11'"
                          >
                            <span class="badge badge-success"
                              >Planner Admin</span
                            >
                          </span>
                           <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '12'"
                          >
                            <span class="badge badge-success"
                              >Planner</span
                            >
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '13'"
                          >
                            <span class="badge badge-success"
                              >Buying Head</span
                            >
                          </span>
                          <span
                            data-toggle="tooltip"
                            title="User Type"
                            v-if="row.item.user_type == '14'"
                          >
                            <span class="badge badge-success"
                              >PLM User</span
                            >
                          </span>


                      </template>

                      <template
                        slot="edituser"
                        slot-scope="row"
                        v-if="row.item.user_type == '1'"
                      >
                        <i
                          @click="managecatmodelfn(row.item)"
                          data-toggle="tooltip"
                          class="fa fa-pencil-square-o"
                          aria-hidden="true"
                          style=" color: green;"
                          ><label style="color:black">Assign New Sub Cat</label>
                        </i>
                        <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->
                      </template>

                      <template slot="active" slot-scope="row" >
                        <button :disabled="row.item.user_type == 4 || row.item.user_type == 6 || row.item.user_type == 0 ||  row.item.user_type == 7 || row.item.user_type == 8 ||  row.item.user_type == 9 ||  row.item.user_type == 12  ||  row.item.user_type == 14" class="btn" @click="showActiveUserListModal(row.item)">
                            Active 
                        </button>
                      </template>

                      <template slot="actions" slot-scope="row">
                        <i
                          @click="editinfoModal(row.item)"
                          data-toggle="tooltip"
                          title="Update Vendor Details"
                          class="fa fa-pencil-square-o"
                          aria-hidden="true"
                          style=" color: green;"
                          >&nbsp;&nbsp;&nbsp;&nbsp;
                          <!-- <i class="fa fa-edit"></i> -->
                        </i>
                        <i
                          v-on:click="deleteinfoModal(row.item)"
                          data-toggle="tooltip"
                          title="Delete Vendor Details"
                          class="fa fa-trash"
                          aria-hidden="true"
                          style="color: red"
                        >
                          <!-- <i class="fa fa-trash" aria-hidden="true" style="color: red"></i> -->
                        </i>
                      </template>

                      <template
                        slot="actions"
                        slot-scope="row"
                        v-if="
                          user_type == 'Brand_Manager' ||
                            user_type == 'Admin' ||
                            user_type == 'Quality_Controller' ||
                            user_type == 'Buyer' ||
                            user_type == 'Planner_Admin'
                        "
                      >
                        <i
                          @click="userupdatefunction(row.item)"
                          data-toggle="tooltip"
                          class="fa fa-pencil-square-o"
                          aria-hidden="true"
                          style=" color: green;"
                          ><label style="color:black">Edit User Details</label>
                        </i>
                        <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->
                      </template>
                    </b-table>
                  </b-col>
                </b-card-body>
              </b-col>
            </div>
          </b-row>
          <!-- code for table ends -->
          <!-- <b-col md="6" class="my-1" v-if="this.user_totalRows > 10"> -->
          <div class="col-md-12">
            <b-pagination
              v-model="currentPage"
              :total-rows="CreatedUser_totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </div>
          <!-- </b-col>  -->

            <!-- Modal for active and deactive user -->

            <b-modal size="md" title="Are you sure, want to deactive user?" v-model="showActiveUserList" @ok="showActiveUserList = false"> <!-- assuming you have a modal component -->
               <h5>Please select User</h5>
                   
                <!-- getCreatedUserList -->
                <form  @submit.prevent="validateForm2('form-2')"
                    data-vv-scope="form-2">
                          <b-form-select  class="form-control col-md-12" id="user_id" name="User Name" v-model="deactiveuser"  v-validate="'required'"
                           >
                                <option value="null">Select User</option>
                                <option v-for="user in userList" :value="user.user_id" v-if="selectedDeactiveId && user.user_id != selectedDeactiveId" >
                                    Name:&nbsp; {{ user.full_name }}, &nbsp;&nbsp; Email Id:&nbsp;  {{ user.email_id }}
                                </option>
                            </b-form-select> 
                            <b-input-group>
                                <span class="icon has-text-warning">
                                <i
                                    class="fa fa-warning"
                                    v-show="errors.has('User Name')"
                                ></i>
                                </span>
                                <span
                                style="width:240px"
                                v-show="errors.has('form-2.User Name')"
                                class="help text-danger"
                                >{{ errors.first("form-2.User Name") }}</span
                                >
                            </b-input-group>
                        <!-- </b-form-group> -->

                        <div style="text-align: right !important;" class="mt-4">
                            <b-button variant="primary"  size="md" type="submit" class=""
                                >Submit</b-button
                                >
                             <b-button variant="danger"  size="md" type="button" @click="cancelshowActiveUserList" class="ml-1"
                                >Cancel</b-button
                                >
                        </div>


                
                    
                </form>
            </b-modal>
            <!-- Modal for active and deactive user  end -->

          <!-- Code For Select Brand -->
          <b-modal
            id="selectbrandmodel"
            size="md"
            title="Add Existing User"
            v-model="showexistingusermodel"
            @ok="showexistingusermodel = false"
          >
            <form>
              <div>
                <div class="col-md-12">
                  <!-- <b-form-select class="form-control" id="user_id" name="user_id" v-validate="'required|'" v-model="selected_user">
                                <option value="selected">Select User</option>
                                <option v-for="user in user_list" :value="user.user_id">
                                   Name:&nbsp; {{ user.full_name }} &nbsp;&nbsp; Role:&nbsp;  {{ user.role }}
                                </option>

                            </b-form-select>  -->

                  <b-row class="col-md-12 ">
                    <b-col md="2" class="searchcol2"
                      ><label class="usersearch"><b>Search:</b></label></b-col
                    >

                    <b-col md="6" class="inputcol6">
                      <input
                        type="text"
                        id="myInput"
                        v-model="searchexisitinguser"
                        v-on:keyup="getsearchvaluefromexisting(searchexisitinguser)"
                        placeholder="Search for names..."
                        title="Type in a name"
                        class="searchinput"
                      />
                    </b-col>
                    <b-col md="4" class="iconcol4"
                      ><i
                        class="fa fa-search"
                        aria-hidden="true"
                        style="padding-top: 8px; color: #24a0ed;margin-left: 68px;"
                      ></i
                    ></b-col> </b-row
                  ><br />
            
                  <b-form-group>
                    <div id="myapp" class="existusertable">
                      <table class="table col-md-12" id="myTable">
                        <thead class="existinguserhead">
                          <tr>
                            <td scope="col">Select</td>
                            <td scope="col">User Name</td>
                            <td scope="col">User Type</td>
                           
                          </tr>
                        </thead>
                        <tbody
                          class="existinguserbody"
                          v-if="user_list_msg == 'Successful'"
                        >
                          <tr v-for="user in user_list">
                            <td class="bodyuserinput">
                              <input
                                type="checkbox"
                                v-bind:value="user.user_id"
                                v-model="selected_user"
                                @change="updateCheckall()"
                                required="selectedvendors"
                              />
                            </td>
                            <td class="bodyusername">{{ user.full_name }}</td>
                            <td class="bodyusertype">{{ user.user_type }}</td>
                           
                          </tr>
                        </tbody>
                        <tbody v-if="user_list_msg == 'Unsuccessful'">
                          <tr>
                            <td colspan="3" style="text-align: center;">
                              No Records Found
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-12 mb-4 text-center">
                <button
                  type="button"
                  @click="addexistinguser()"
                  class="btn btn-success submit_btn invoice-save-bottom"
                  style="float: right;"
                >
                  Assign User
                </button>
              </div>
            </form>
          </b-modal>

          <!-- Code For Select Brand Ends -->

          <!-- Code Manage Category -->
          <b-modal
            id="managecatmodel"
            size="md"
            title="Add Sub Category"
            v-model="managecatmodel"
            @ok="managecatmodel = false"
          >
            <form>
              <!-- <div  class='col-md-12' > 
                            <label for="name">Select Brand Manager</label>

                            <select class="form-control" id="selected_brand_manager" name="selected_brand_manager" v-validate="'required|'" v-model="selected_brand_manager">
                                <option value=selected>Select Brand Manager</option>
                                

                            </select> 

                          </div> -->

              <label for="name">Select Sub Category!!!!!</label><br />
              <input type='checkbox' @click='checkAll()' v-model='isCheckAll'> Check All!!!!
              <div
                id="myapp"
                class="col-md-12"
                style="height: 200px;overflow-y: scroll;"
              >
                <br />

                <table class="table col-md-12" id="myTable">
                  <thead>
                    <tr>
                      <td scope="col">Sub Cat ID</td>
                      <td scope="col">Subcategory Name</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="opt in sub_cat_arr">
                      <td>
                        <input
                          type="checkbox"
                          v-bind:value="opt.sub_catid"
                          v-model="selected_sub_cat"
                          @change="
                            updatedcheck(opt.sub_catid, selected_sub_cat)
                          "
                       row.item.user_type == 8    required="selected_sub_cat"
                        />&nbsp;{{ opt.sub_catid }}
                      </td>
                      <td>{{ opt.sub_cattitle }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12 mb-4 text-center">
                <button
                  type="button"
                  @click="updatedsubcat()"
                  class="btn btn-success submit_btn invoice-save-bottom"
                  style="float: right;"
                >
                  <i class="fa fa-save"></i>
                  Assign Sub Category
                </button>
              </div>
            </form>
          </b-modal>

          <!-- Code For Manage Category Ends -->

          <!-- Code Manage Category -->
          <b-modal
            id="userupdatemodel"
            size="md"
            title="Update User Details"
            v-model="userupdatemodel"
            @ok="userupdatemodel = false"
          >
            <form
              @submit.prevent="validateForm('form-1')"
              data-vv-scope="form-1"
            >
              <div id="myapp" class="col-md-12">
                <b-form-group label="Full Name" :label-cols="3">
                  <b-form-input
                    type="text"
                    name="selected_full_name"
                    v-model="selected_full_name"
                    placeholder="Enter Full Name"
                    v-validate="'required|min:3|max:30'"
                    :class="{
                      input: true,
                      'text-danger': errors.has('form-1.selected_full_name'),
                    }"
                  >
                  </b-form-input>
                  <b-input-group>
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_full_name')"
                      ></i>
                    </span>
                    <span
                      style="width:240px"
                      v-show="errors.has('form-1.selected_full_name')"
                      class="help text-danger"
                      >{{ errors.first("form-1.selected_full_name") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <b-form-group label="Email ID" :label-cols="3">
                  <b-form-input
                    type="text"
                    name="selected_email_id"
                    v-model="selected_email_id"
                    v-validate="'required|email'"
                    :class="{
                      input: true,
                      'text-danger': errors.has('form-1.selected_email_id'),
                    }"
                    placeholder="Enter Email ID"
                  >
                  </b-form-input>
                  <b-input-group class="mb-3">
                    <span
                      style="width:240px"
                      v-show="errors.has('form-1.selected_email_id')"
                      class="help text-danger"
                      >{{ errors.first("form-1.selected_email_id") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <b-form-group label="Contact No." :label-cols="3">
                  <b-form-input
                    type="text"
                    name="selected_contact_no"
                    v-model="selected_contact_no"
                    v-validate="'required|digits:10'"
                    :class="{
                      input: true,
                      'text-danger': errors.has('form-1.contact_no'),
                    }"
                    placeholder="Enter Contact Number"
                  >
                  </b-form-input>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_contact_no')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-1.selected_contact_no')"
                      id="addmblnbrmsg"
                      class="help text-danger"
                      >{{ errors.first("form-1.selected_contact_no") }}
                    </code>
                  </b-input-group>
                </b-form-group>
                <b-form-group label="User Type" :label-cols="3">
                  <b-form-select
                    v-if="this.user_type == 'Brand_Manager'"
                    v-model="selected_user_type"
                    name="role"
                    v-validate="'required|'"
                    :class="{
                      input: true,
                      'is-invalid': errors.has('form-1.selected_user_type'),
                    }"
                    @change="displaydesignation(selected_user_type)"
                  >
                    <option value="">--Select--</option>
                    <option value="2">Buyer</option>
                    <option value="3">Designer</option>
                    <option value="4">Fit Technician</option>
                    <option value="5">Design Head</option>
                    <option value="6">PO Executive</option>
                  </b-form-select>

                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_user_type')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-1.selected_user_type')"
                      id="statustxt"
                      class="help text-danger"
                      >{{ errors.first("form-1.selected_user_type") }}
                    </code>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Designation"
                  :label-cols="3"
                  id="designation_block"
                  v-if="block_value == 1"
                >
                  <b-input-group>
                    <b-form-select
                      v-model="selected_designation"
                      name="selected_designation"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-1.selected_designation'),
                      }"
                    >
                      <option value="">--Select--</option>
                      <option value="Senior Buyer">Senior Buyer</option>
                      <option value="Junior Buyer">Junior Buyer</option>
                    </b-form-select>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_designation')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-1.selected_designation')"
                      id="statustxt"
                      class="help text-danger"
                      >{{ errors.first("form-1.selected_designation") }}
                    </code>
                  </b-input-group>
                </b-form-group>

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Submit</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="submit"
                      @click="$router.push('usersdetails')"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </div>
            </form>
          </b-modal>

          <!-- Code For Edit Userdetails Ends -->
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
import { search } from "core-js/fn/symbol";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarSettingsComponent,
  },
  data() {
    return {
      isBusy: false,
      sampelAddModal: false,
      customer: {},
      addAgentMaster: false,
      editAgentMaster: false,
      bordered: true,
      showSideMenu: true,
      items: [],
      result: [],
      value: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortDesc: true,
      sortDirection: "desc",
      user_type: "",
      sortBy: null,
      //,tdClass: 'userclass'
      fields: [
        // { key: 'user_id', label: 'User ID', sortable: true, sortDirection: 'desc', },
        { key: "full_name", label: "Full Name", sortable: true },
        {
          key: "email_id",
          label: "Email ID",
          sortable: true,
          tdClass: "email_data",
        },
        { key: "contact_no", label: "Contact No" },
        { key: "created_date", label: "Created Date" },
        { key: "user_type", label: "User Type" },
        // { key: "designation", label: "Designation" },
        // { key: "city", label: "Assigned City" },
        
        { key: "actions", label: "Actions" },
        { key: "active", label: "Active User"},
      ],
      showexistingusermodel: false,
      user_list: [],
      selected: "",
      selected_brand_id: 0,
      selected_user: [],
      selected_user_length: 0,
      isCheckAll: false,
      user_list_msg: "",
      items_message: "",
      user_totalRows: 0,
      CreatedUser_totalRows: 0,
      managecatmodel: false,
      // subcat_list: [],
      sub_cat_arr: [],
      selected_user_brand_id: "",
      temp_subcat_arr: [],
      selected_user_id: 0,
      selected_full_name: "",
      selected_email_id: "",
      selected_contact_no: "",
      selected_user_type: "",
      selected_designation: "",
      selected_cat_id: "",
      userupdatemodel: false,
      block_value: 0,
      searchexisitinguser:'',
      searchvalue:'',
      showActiveUserList: false,
      deactiveuser:null,
      selectedDeactiveId:null,
      userlist:[],
      typeUser:'',
      searchuser:"",
    };
  },
  created: function() {
    this.getCreatedUserList();
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.user_type = userInfo[0].user_type;
    // if (this.user_type != "Admin" && this.user_type != "Quality_Controller") {
    //   this.getexistinguserlist(this.searchvalue);
    // }
  },

  methods: {
    //Update User Details
    userupdatefunction: function(values) {
      var route_id = values.user_id;
      this.$router.push({
        name: "updateuserdetails",
        params: { id: route_id },
      });
    },

    displaydesignation(value) {
      if (value == 2) {
        this.block_value = 1;
      } else {
        this.block_value = 0;
      }
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          alert("1");
          this.updateuserdata();
        }
      });
    },

    //   updateuserdata: function(){
    //     alert("2")
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //  const Obj = {
    //           user_id : this.selected_user_id,
    //           full_name: this.selected_full_name,
    //           email_id: this.selected_email_id,
    //           contact_no: this.selected_contact_no,
    //           user_type: this.selected_user_type,
    //           password:"12345",
    //           created_by:
    //           brand_manager:
    //           sub_catid:
    //           cat_id:
    //           brands:
    //           designation: this.selected_designation
    //         }

    //   this.isBusy = true;
    //   // return false;
    //     axios.post(`${CONSTANTS.API_URL}/updateUserDetails`,Obj)
    //     .then(response => {
    //       document.getElementById("overlay").style.display = "none";
    //       this.result = response.data
    //       this.user_list_msg=this.result.returnmsg;
    //       if (this.result.returnmsg === 'Successful') {
    //         this.userupdatemodel= false;
    //         this.$fire({
    //              text:"User Details Updated Successlly",
    //              type: "success",
    //              timer: 30000
    //                     })
    //         this.selected_user_id='';
    //         this.selected_full_name='';
    //         this.selected_email_id='';
    //         this.selected_contact_no='';
    //         this.selected_user_type='';
    //         this.selected_designation='';
    //         this.selected_cat_id='';
    //         this.isBusy = false;

    //       }else {
    //          this.isBusy = !this.isBusy;
    //       }

    //     })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })

    // },
    //Update User Details Ends
    //Code For Select SubCat
    checkAll: function() {
      this.isCheckAll = !this.isCheckAll;
      this.selected_sub_cat = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.sub_cat_arr) {
          this.selected_sub_cat.push(this.sub_cat_arr[key]);
          this.selectedsubcat_length = this.selected_sub_cat.length;
        }
      }
    },
    updateCheckall: function() {
      // alert("In")
      if (this.selected_sub_cat.length > 0) {
        if (this.selected_sub_cat.length == this.sub_cat_arr.length) {
          this.isCheckAll = true;
          this.selectedsubcat_length = this.selected_sub_cat.length;
        } else {
          this.isCheckAll = false;
          this.selectedsubcat_length = this.selected_sub_cat.length;
        }
      } else {
        // alert("Please Select Atleast Sub Category");
        this.$fire({
          text: "Please Select Atleast Sub Category.",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlay").style.display = "none";
      }
    },

    //Code For Select SubCat Ends

    updatedcheck(values, status) {
      console.log("112222222222222", status);

      if (status == true) {
        this.temp_subcat_arr.push(values);
      }

      console.log("EEEEEEEEEEEEEEEEEEEEEEEEEEEEEe", this.temp_subcat_arr);
    },

    updatedsubcat: function(values) {
      console.log("9999999999999999999999999", values);
      // return false;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // this.selected_user_brand_id= values.brand_id
      const Obj = {
        user_id: this.selected_user_id,
        brand_id: this.selected_user_brand_id,
        sub_catid: this.temp_subcat_arr,
      };
      console.log("RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR", Obj);
      this.isBusy = true;
      // return false;
      axios
        .post(`${CONSTANTS.API_URL}/updateSubCategoryListforuser`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          this.user_list_msg = this.result.returnmsg;
          if (this.result.returnmsg === "Successful") {
            this.selected_sub_cat = "";
            this.temp_subcat_arr = "";
            this.managecatmodel = false;
            this.$fire({
              text: "Sub Category Updated Successlly",
              type: "success",
              timer: 30000,
            });
            // this.subcat_list  = this.result.returnvalue;
            // this.user_totalRows = this.result.returnvalue.length;
            this.isBusy = false;
          } else {
            // this.user_list =[];
            // this.user_totalRows=0;
            this.isBusy = !this.isBusy;
            // this.managecatmodel =!this.managecatmodel
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    managecatmodelfn: function(values) {
      console.log("&&&&&&&&&&&&&&&&&&&&&&", values);
      // alert("In")
      this.managecatmodel = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.selected_user_brand_id = values.brand_id;
      this.selected_user_id = values.user_id;
      const Obj = {
        user_id: this.selected_user_id,
        brand_id: this.selected_user_brand_id,
      };
      this.isBusy = true;
      axios
        .post(`${CONSTANTS.API_URL}/getSubCategoryListforuser`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          this.user_list_msg = this.result.returnmsg;
          if (this.result.returnmsg === "Successful") {
            console.log(
              "9999999999999999999999999999999999",
              this.result.returnvalue
            );
            this.sub_cat_arr = this.result.returnvalue.Not_Assigned_sub_category;
            this.user_totalRows = this.result.returnvalue.length;
            this.isBusy = false;
          } else {
            this.sub_cat_arr = [];
            this.user_totalRows = 0;
            this.isBusy = !this.isBusy;
            // this.managecatmodel =!this.managecatmodel
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.user_totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showexistinguser: function() {
      this.showexistingusermodel = !this.showexistingusermodel;
    },

    //Code For Add User
    checkAll: function() {
      this.isCheckAll = !this.isCheckAll;
      this.selected_user = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.user_lists) {
          this.selected_user.push(this.user_list[key]);
          this.selected_user_length = this.selected_user.length;
        }
      }
    },
    updateCheckall: function() {
      if (this.selected_user.length == this.user_list.length) {
        this.isCheckAll = true;
        this.selected_user_length = this.selected_user.length;
      } else {
        this.isCheckAll = false;
        this.selected_user_length = this.selected_user.length;
      }
    },
    //Code For Add User Ends

    //Code For Existing User List
    getexistinguserlist: function(value) {
      // document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.selected_brand_id = userInfo[0].brand_assign;
      const Obj = {
        brand_manager: userInfo[0].user_id,
        brand_id: userInfo[0].brand_assign,
        search_value: value,
      };
      this.isBusy = true;
      axios
        .post(`${CONSTANTS.API_URL}/getExistingUsers`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          this.user_list_msg = this.result.returnmsg;
          if (this.result.returnmsg === "Successful") {
            this.user_list = this.result.returnvalue;
            this.user_totalRows = this.result.returnvalue.length;
            this.isBusy = false;
          } else {
            this.user_list = [];
            this.user_totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    //Code For Existing User List Ends

    //Code for add existing user
    addexistinguser: function() {
      document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var userarr = [];
      userarr = this.selected_user;
      this.selected_brand_id = userInfo[0].brand_assign;
      const Obj = {
        selected_user: [userarr],
        created_by: userInfo[0].user_id,
        brand_manager: userInfo[0].user_id,
        brand_id: userInfo[0].brand_assign,
      };

      axios
        .post(`${CONSTANTS.API_URL}/addExistingUsers`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.showexistingusermodel = false;
            // alert("User Added Successlly");
            this.$fire({
              text: "User Added Successlly",
              type: "success",
              timer: 30000,
            });
            this.selected_user = []
            this.getCreatedUserList();
            this.isBusy = false;
          } else {
            // alert("User Not Added");
            this.$fire({
              text: "User Not Added",
              type: "warning",
              timer: 30000,
            });
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    //Code for add existing user ends

    getCreatedUserList: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      // console.log("%%%%%%%%%%%%%%%%%333333333333333333%", userInfo[0]);

      // document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.login_user_id = userInfo[0].user_id;
      // if(userInfo[0].user_type=='Quality_Controller'){
      //   var Obj = {
      //         created_by : this.login_user_id,
      //         user_type: userInfo[0].user_type,
      //         // brand_id: userInfo[0].brand_assign
      //       }
      // }
      // else{
      var Obj = {
        created_by: this.login_user_id,
        user_type: userInfo[0].user_type,
        brand_id: userInfo[0].brand_assign,
        search_value: this.searchuser ? this.searchuser : '',
      };
      // }

      // this.isBusy = true;
      axios
        .post(`${CONSTANTS.API_URL}/getCreatedUserList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          this.isBusy != this.isBusy;
          if (this.result.returnmsg === "Successful") {
            this.items = this.result.returnvalue;
            this.CreatedUser_totalRows = this.result.returnvalue.length;
            // this.isBusy = false;
          } else {
            this.items = [];
            this.CreatedUser_totalRows = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    //Code For Search Filter
    myFunction: function() {
        console.log(this.searchexisitinguser)
      var input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toUpperCase();
      table = document.getElementById("myTable");
      tr = table.getElementsByTagName("tr");
      console.log("RRRRRRRRRRRRRRrr", tr);
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },
    //Code For Search Filter
    
    showActiveUserListModal(data){
        document.getElementById("overlay").style.display = "block";
        this.selectedDeactiveId = data.user_id;
        this.showActiveUserList = true;
            const obj ={
                user_id : data.user_id,
                role: data.user_type
            }
            // this.isBusy = true;
        axios
            .post(`${CONSTANTS.API_URL}/exsitingUserlistaccrodingtorole`, obj)
            .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            this.typeUser =  data.user_type
            this.isBusy != this.isBusy;
            if (this.result.returnmsg === "Successful") {
                this.userlist = this.result.returnvalue;
                this.CreatedUser_totalRows = this.result.returnvalue.length;
                // this.isBusy = false;
            }else if (response.data.returnmsg.toLowerCase() == "unsuccessful") {
            this.userlist = [];
            this.CreatedUser_totalRows = 0;
            this.$fire({
            text: response.data.returnvalue,
            type: "error",
            timer: 30000,
            });
          } else {
            this.userlist = [];
            this.CreatedUser_totalRows = 0;
            this.$fire({
            text: 'Error while getting user specific role',
            type: "error",
            timer: 30000,
            });
          }
          })
          .catch((e) => {
          this.errors.push(e);
          });
    },

    validateForm2(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
        document.getElementById("overlay").style.display = "block";
            const obj ={
                deactive_user_id : this.selectedDeactiveId,
                assigned_user_id : this.deactiveuser,
                is_deactive : 'yes',
                user_type: this.typeUser
            }
            if(this.user_type != 'Admin'){
            axios
            .post(`${CONSTANTS.API_URL}/foruserdeactivate`, obj)
            .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            this.isBusy != this.isBusy;
            if (this.result.returnmsg === "Successful") {
                 this.$fire({
                    text: "User Deactivated Successfully",
                    type: "success",
                    timer: 30000,
                    });
                 this.showActiveUserList = false;
                 this.getCreatedUserList()
            }else if(response.data.returnmsg.toLowerCase() == "unsuccessful"){
                this.$fire({
                text: response.data.returnvalue,
                type: "error",
                timer: 30000,
                });
            }else {
              this.$fire({
                text: "Something went wrong",
                type: "error",
                timer: 30000,
                });
            }
            })
          }else{
            axios
            .post(`${CONSTANTS.API_URL}/forDeactiveUserBMQCWise`, obj)
            .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            this.isBusy != this.isBusy;
            if (this.result.returnmsg === "Successful") {
                 this.$fire({
                    text: "User Deactivated Successfully",
                    type: "success",
                    timer: 30000,
                    });

                 this.showActiveUserList = false;
                 this.getCreatedUserList()
            }else if(response.data.returnmsg.toLowerCase() == "unsuccessful"){
                this.$fire({
                text: response.data.returnvalue,
                type: "error",
                timer: 30000,
                });
          } else {
                 this.$fire({
                    text: "Something went wrong",
                    type: "error",
                    timer: 30000,
                    });
            }
            })
          }
        }
        else{
            this.$fire({
              text: "Something went wrong, please try again",
              type: "error",
              timer: 30000,
            });
        }
       
      });
    },

    cancelshowActiveUserList(){
        this.deactiveuser = null
        this.showActiveUserList = false;
    },

    searchuserfromlist(list){
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
      this.searchuser = list;
      this.getCreatedUserList();
      }, 700); // Call after 700ms of inactivity
    },

    // getexistinguserlist
    getsearchvaluefromexisting(value){
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
      this.getexistinguserlist(value);
      }, 700); // Call after 700ms
    }


  },
};
</script>
<style>
.account-settings__content > * {
  flex-grow: 1;
}

.profile-settings {
  flex-grow: 1;
  padding: 20px 24px;
}

.profile-settings > h1 {
  font-weight: 600;
  padding: 0;
  margin: 0;
}
.profile-settings .content {
  display: flex;
}
.profile-settings .content .profile-fields-container {
  max-width: 356px;
  margin-right: 56px;
}
.profile-settings .tabular-fields {
  font-size: 14px;
  line-height: 20px;
  flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
  margin-top: 20px;
  min-height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.profile-settings .tabular-fields .field-row > .field-label {
  color: var(--fill-grey-medium);
  min-width: 100px;
  margin: 12px 0;
}
.profile-settings .tabular-fields .field-row > .field-value {
  margin-left: 32px;
  flex-grow: 1;
}

.design-container-details__main {
  background-color: white;
  border-left: 1px solid #d4d4d4;
}

.profile-settings .content .img.img-invalid {
  background-color: #6f4ce6;
}
.profile-settings .content .img {
  max-width: 100%;
  position: relative;
  height: 175px;
  width: 175px;
  border-radius: 4px;
  overflow: hidden;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid var(--fill-grey-light2);
  padding: 5px;
}
.userclass {
  word-wrap: break-word;
  column-width: fixed;
  max-width: 150px !important;
}
.dot {
  height: 2px !important;
  width: 2px !important;
  background-color: #f30d37;
  border-radius: 50%;
  display: inline-block;
}
.usersearch {
  font-size: 15px;
  padding-top: 4px;
}
.searchinput {
  width: 300px;
  height: 32px;
}
.existusertable {
  height: 200px;
  overflow-y: scroll;
}

@media (max-width: 1040px) {
  .userdetailside {
    display: none;
  }
}
@media (min-width: 1040px) {
  .userdetailsidebar {
    display: none;
  }
}
@media (max-width: 766px) {
  .existusertable {
    height: 200px;
    overflow-y: scroll;
  }
  .searchinput {
    width: 250px;
    height: 32px;
  }
  .searchcol2 {
    width: 100px;
  }
  .inputcol6 {
    width: 36%;
  }
  .iconcol4 {
    width: 10px;
  }
}
@media (max-width: 470px) {
  .existusertable {
    height: 200px;
    overflow-y: scroll;
  }
  .searchinput {
    width: 200px;
    height: 32px;
  }
  .inputcol6 {
    width: 36%;
  }
  .existinguserbody {
    font-size: 12px;
  }
  .existinguserhead {
    font-size: 12px;
  }
  .bodyusertype {
    width: 10px;
  }
  .bodyusername {
    width: 10px;
  }
  .email_data {
    width: 80px !important;
    word-wrap: break-word;
  }
  /*.bodyuserinput{
  width:50px;
 }*/
}
@media (max-width: 390px) {
  .existusertable {
    height: 200px;
    overflow-y: scroll;
  }
  .searchinput {
    width: 150px;
    height: 32px;
  }
  .existinguserbody {
    font-size: 12px;
  }
  .inputcol6 {
    width: 25%;
  }
  .existinguserhead {
    font-size: 12px;
  }
  .bodyusertype {
    width: 10px;
  }
  .bodyusername {
    width: 10px;
  }
  #myapp {
    width: 105%;
  }
  /*.bodyuserinput{
  width:50px;
 }*/
}
@media (max-width: 320px) {
  .existusertable {
    height: 200px;
    overflow-y: scroll;
  }
  .searchinput {
    width: 120px;
    height: 32px;
  }
  .existinguserbody {
    font-size: 12px;
  }
  .inputcol6 {
    width: 15%;
  }
  .existinguserhead {
    font-size: 12px;
  }
  .bodyusertype {
    width: 10px;
  }
  .bodyusername {
    width: 10px;
  }
  #myapp {
    width: 105%;
  }
  /*.bodyuserinput{
  width:50px;
 }*/
}
</style>
